import type { CreateProjectSheetProps } from "./CreateProjectSheet.types";
import { CreateProjectWizard } from "components/common/CreateProjectFlow/CreateProjectWizard";

export const CreateProjectSheet = ({
  isOpen,
  onClose,
  onSuccess,
  existingProject,
  mode = "project",
  initialSource,
  initialFile,
  entrySource,
}: CreateProjectSheetProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <CreateProjectWizard
      isActive={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingProject={existingProject}
      mode={mode}
      initialSource={initialSource}
      initialFile={initialFile}
      entrySource={entrySource}
    />
  );
};
